import React from "react";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
export function ModalLogadosSemana(props) {
    return (
        <div className="modal fade show" id="modal-xl" style={{ display: "block" }} aria-modal="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Usuários Logados</h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.handleClose}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Table responsive>
                            <THead>
                                <Tr>
                                    <Th>Nome</Th>
                                    <Th>Cliente</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {props.listaLogados
                                    .filter((item) => item.tipo == "logado" || item.tipo == "semana")
                                    .map((item) => (
                                        <Tr key={item.id}>
                                            <Td>{item.nome}</Td>
                                            <Td>{item.nome_tipo}</Td>
                                        </Tr>
                                    ))}
                            </TBody>
                        </Table>
                    </div>
                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-default" data-dismiss="modal" style={{ visibility: "hidden" }}>
                            Fechar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={props.handleClose}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
